import { Immutable } from "immer";
import React from "react";

import type { SidekickBlock as Value } from "@reactivated";

// NOTE: This is the STANDALONE render of the sidekick block, intended for the
// styleguide and the Phase-2 assembly path. In the legacy `cms/landing_page.html`
// the sidekick is rendered inside a page-context wrapper
// (`home-page-hero-mobile-promo landing-page-hero-mobile-promo`) that also
// includes a SHOP NOW button derived from the page's `hero_product` — none of
// which the block can resolve on its own. We therefore render ONLY the block's
// own content: the tagline + description divs (using the same classnames the
// legacy `hero_sidekick` branch applies). The wrapper + SHOP NOW button are
// added by the Phase-2 page assembly later. So this standalone render is an
// intentional SUBSET of the full page render.
//
// Both fields are RichTextBlock (HTML strings, already serialized with the
// `<div class="rich-text">` wrapper by the server), so render via
// dangerouslySetInnerHTML.
type IProps = Immutable<{
    value: Value;
}>;

export const SidekickBlock = (props: IProps): React.JSX.Element => {
    const v = props.value;

    return (
        <>
            <div
                className="home-page-hero-mobile-promo__tagline landing-page-hero-mobile-promo__tagline"
                dangerouslySetInnerHTML={{
                    __html: v.sidekick_tagline ?? "",
                }}
            />
            <div
                className="home-page-hero-mobile-promo__copy landing-page-hero-mobile-promo__copy"
                dangerouslySetInnerHTML={{
                    __html: v.sidekick_description ?? "",
                }}
            />
        </>
    );
};
